// Navigation pages configuration
export const NAVIGATION_PAGES = ["Home", "About Us", "Faq", "Deliveries & Returns", "Contact Us"];

// Company information
export const COMPANY_INFO = {
  name: "SB Ink Brits",
  tagline: "Need INK, Think SB INK",
  established: "1998",
  britsPhone: "012 252 3750",
  britsWhatsApp: "072 498 1672",
  pretoriaPhone: "074 182 0281",
  pretoriaWhatsApp: "074 182 0281",
  email: "sales@sb.co.za",
  pretoriaEmail: "sales@sbink.co.za",
  britsAddress: "33 Ludorf St, CBD, Brits, 0250",
  pretoriaAddress: "465 Gerrit Maritz Rd, Pretoria North, Pretoria, 0182",
  website: "www.sbink.co.za",
  facebook: "https://www.facebook.com/profile.php?id=100063573536514",
  googleReview: "https://www.google.com/search?q=SB+INK+Brits"
};

// Color theme
export const THEME_COLORS = {
  primary: "#e42200",
  primaryDark: "#ff2600",
  white: "#ffffff",
  black: "#000000",
  gray: "#989898"
};

// Breakpoints
export const BREAKPOINTS = {
  mobile: '(min-width:768px)',
  tablet: '(min-width:770px)'
};

// Routes
export const ROUTES = {
  HOME: '/Home',
  ABOUT: '/AboutUs',
  FAQ: '/Faq',
  DELIVERIES: '/Deliveries&Returns',
  CONTACT: '/ContactUs'
};
